import { readonly, ref } from 'vue'

export const THEME_OPTIONS = ['light', 'dark', 'system']
const STORAGE_KEY = 'retiora-theme'

const preference = ref('system')
let mediaQuery
let initialized = false

function isTheme(value) {
  return THEME_OPTIONS.includes(value)
}

function resolvedTheme() {
  if (preference.value !== 'system') return preference.value
  return mediaQuery?.matches ? 'dark' : 'light'
}

function applyTheme() {
  if (typeof document === 'undefined') return
  const value = resolvedTheme()
  document.documentElement.dataset.theme = value
  document.documentElement.classList.toggle('app-dark', value === 'dark')
  document.documentElement.style.colorScheme = value
}

function handleSystemThemeChange() {
  if (preference.value === 'system') applyTheme()
}

export function initializeTheme() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  const savedPreference = window.localStorage.getItem(STORAGE_KEY)
  if (isTheme(savedPreference)) preference.value = savedPreference

  mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  mediaQuery.addEventListener('change', handleSystemThemeChange)
  applyTheme()
}

export function useTheme() {
  function setTheme(value) {
    if (!isTheme(value)) return
    preference.value = value
    window.localStorage.setItem(STORAGE_KEY, value)
    applyTheme()
  }

  return {
    theme: readonly(preference),
    setTheme,
  }
}
